<template>
  <section>
    <div class="topup-error" v-if="formError">
      <h3>Uzupełnij wszystkie wymagane pola formularza!</h3>
    </div>
    <form class="topup-form" @submit="submit">
      <div class="topup-form-frame">
        <h2><strong>Krok 1</strong> - Numer telefonu i e-mail</h2>
        <h1>Podaj numer telefonu i adres e-mail</h1>
        <div class="topup-form-fields">
          <div>
            <section class="topup-form-field-zone" v-for="(topup, topupIndex) in form.topup" :key="topupIndex">
              <div class="topup-form-field">
                <div class="topup-form-field-container" :class="{error: hasTopupError(topupIndex)}">
                  <label :for="'form-phone-' + topupIndex">Numer telefonu, który chcesz doładować *</label>
                  <input type="text"
                         :id="'form-phone-' + topupIndex"
                         class="topup-phone"
                         ref="topupPhoneInput"
                         v-model="topup.phone"
                         :disabled="isCheckPhoneInProgress(topupIndex)"
                         autocomplete="off"
                         @keyup="checkPhone(topupIndex)"
                         @paste="checkPhoneOnPaste($event, topupIndex)"
                         v-mask="'###-###-###'"
                         placeholder="___-___-___">
                  <button type="button"
                          class="remove-topup"
                          @click="removeTopup(topupIndex)"
                          v-if="canRemoveTopup() && !isCheckPhoneInProgress(topupIndex)">
                    <font-awesome-icon :icon="['far', 'trash-alt']" />
                  </button>
                  <font-awesome-icon :icon="['fas', 'spinner']" spin v-if="isCheckPhoneInProgress(topupIndex)" />
                </div>
                <div class="topup-form-error-container  phone-error" v-if="hasTopupError(topupIndex)">
                  <ul>
                    <li v-if="isPhoneEmpty(topupIndex)">Numer telefonu jest wymagany</li>
                    <li v-if="!isPhoneEmpty(topupIndex) && !isPhoneValid(topupIndex)">Numer telefonu jest nieprawidłowy</li>
                    <li v-if="isCheckPhoneError(topupIndex)">Numer telefonu nie może być doładowany</li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
          <div>
            <section class="topup-form-field-zone">
              <div class="topup-form-field">
                <div class="topup-form-field-container" :class="{error: hasEmailError()}">
                  <label for="form-email">Adres e-mail *</label>
                  <input type="text"
                         id="form-email"
                         v-model="form.email"
                         @blur="checkEmail"
                         @focus="setEmailValid(null)"
                         placeholder="podaj adres e-mail">
                </div>
                <div class="topup-form-error-container email-error" v-if="hasEmailError()">
                  <ul>
                    <li v-if="isEmailEmpty()">Adres e-mail jest wymagany</li>
                    <li v-if="!isEmailEmpty() && !isEmailValid()">Adres e-mail jest nieprawidłowy</li>
                  </ul>
                </div>
                <div class="topup-form-description">
                  Na ten adres e-mail wyślemy potwierdzenie doładowania.
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="topup-form-additional-button">
          <button type="button"
                  id="add-topup"
                  v-if="canAddTopup()"
                  @click="addTopup">
            <span>
              <strong>Dodaj kolejny numer telefonu</strong> (max. {{MAX_TOPUPS}})
            </span>
          </button>
        </div>
      </div>
      <div class="topup-form-buttons">
        <span>* pola wymagane</span>
        <button type="submit"
                :disabled="isLoading || isMaintenanceGlobal"
                id="submit-step-1">Dalej ›</button>
      </div>
    </form>
  </section>
</template>

<script>
import TopupStep1Mixin from '../../../common/mixins/Topup/Stage1.mixin'

export default {
  name: 'TopupStage1',
  mixins: [TopupStep1Mixin]
}
</script>

<style src="../../assets/scss/topup-form.scss" lang="scss"></style>
